import _ from "lodash";

export function make({ ident, ...def }) {
  // if cache is undefined, use offline
  if (def.cache === undefined) {
    def.cache = def.offline;
  }

  const mergeStoreConfig = (cfg) =>
    cfg === false
      ? false
      : _.merge({}, cfg, {
          name: ident,
          options: {
            ...(cfg?.options ?? {}),
            keyPath: "id",
          },
        });

  return {
    ...def,

    // we base everything on ident,
    // as that is the unique identifier for the data,
    ident,

    // how we interact with the service (POKK API)
    service: _.merge(
      {
        baseUrl: `/api/${ident}`,
      },
      def.service
    ),

    // Configure IndexedDB for caching
    cache: mergeStoreConfig(def.cache),

    // Configure IndexedDB for offline
    offline: mergeStoreConfig(def.offline),
  };
}

/**
 * DataLayer definition
 *
 * This function defines a data layer for a specific entity (identified by `ident`).
 *
 * @param {Map} list - A Map to store the definitions, typically imported from #/def/data-layer
 * @param {object} parameters
 * @returns object
 */
export function def(list, { ident, ...def }) {
  list.set(ident, make({ ident, ...def }));

  return ident;
}
